module.exports = __webpack_public_path__ + "static/media/icon_pix.b85c870b.svg";